$(document).ready(function() {
  // ПЛАВНЫЙ СКРОЛЛ ДО ЯКОРЯ
  $(document).on('click', 'a[href$=from]', function(){
    elementClick = $(this).attr("href");
    destination = $(elementClick).offset().top;
    $('html, body').animate({scrollTop:destination  - 80},400);
  });
});
